
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4e1a4f9e&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Labor.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Labor.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-4e1a4f9e!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Labor.vue"),
  /* scopeId */
  "data-v-4e1a4f9e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Labor.vue
// module id = 848
// module chunks = 2